import React from "react"
import { Highlight, Snippet } from "react-instantsearch-dom"
import { Link } from "gatsby"
import linkResolver from "utils/linkResolver"

export const CompanyHit = clickHandler => ({ hit }) => (
    <div>
        <Link to={linkResolver({ ticker: hit.ticker, type: "overview" })} onClick={clickHandler}>
            <h4>
                <Highlight attribute="shortName" hit={hit} tagName="mark" />
            </h4>
        </Link>
        <Snippet attribute="json" hit={hit} tagName="mark" />
    </div>
)

export const ArticleHit = clickHandler => ({ hit }) => (
    <div>
        <Link to={linkResolver({ slug: hit.slug, type: "article" })} onClick={clickHandler}>
            <h4>
                <Highlight attribute="headline" hit={hit} tagName="mark" />
            </h4>
        </Link>
        <Snippet attribute="shortDescription" hit={hit} tagName="mark" />
    </div>
)

export const QuestionHit = clickHandler => ({ hit }) => (
    <div>
        <Link to={linkResolver({ slug: hit.slug, type: "question" })} onClick={clickHandler}>
            <h4>
                <Highlight attribute="headline" hit={hit} tagName="mark" />
            </h4>
        </Link>
        <Snippet attribute="json" hit={hit} tagName="mark" />
    </div>
)
